import classNames from 'classnames'
import CloseIcon from 'src/images/icons/CloseIcon'
import { useModalSheet } from 'src/components/contexts/ModalSheetContext'
import { useMobile } from 'src/hooks/useMobile'

import { Overlay } from '../Overlay/Overlay'

export const ModalSheet = () => {
  const { isMobile } = useMobile()

  const { isModalOpen, closeModal, modalConfig } = useModalSheet()

  if (!modalConfig) {
    return null
  }

  const {
    content,
    contentHasInternalScroll = false,
    height = '570px',
    width = '485px',
    position = isMobile ? 'bottom' : 'right',
    variation = 'default',
    title,
    header = { isVisible: true, component: undefined },
  } = modalConfig

  const isDesktopInsetVariation =
    variation === 'desktopInset' && !isMobile && position === 'right'

  const transitionClasses = classNames(
    'transition-all duration-300 ease-out',
    !isModalOpen &&
      (position === 'bottom' ? 'translate-y-full' : 'translate-x-full')
  )

  const Header = header?.component ?? (
    <div className="w-full p-7 flex justify-between">
      <span className="text-xl sm:text-2xl font-medium">{title}</span>
      <button
        data-testid="modal-sheet-close-button"
        onClick={() => closeModal()}
      >
        <CloseIcon />
      </button>
    </div>
  )

  return (
    <div
      data-testid="modal-sheet"
      className={classNames(
        isModalOpen ? 'visible' : 'invisible',
        'fixed top-0 bottom-0 left-0 right-0 z-[99999] inset-0 overflow-hidden overscroll-contain'
      )}
    >
      <Overlay show={isModalOpen} onClick={closeModal} />
      <div
        style={{
          width: isMobile ? '100%' : width,
          height: position === 'bottom' ? height : undefined,
          ...(isDesktopInsetVariation
            ? {
                top: '15px',
                right: '15px',
                bottom: '15px',
                borderRadius: '28px',
              }
            : {}),
        }}
        className={classNames(
          'w-full bg-white absolute overflow-x-hidden overscroll-contain z-[99999999]',
          contentHasInternalScroll ? 'overflow-hidden' : 'overflow-y-auto',
          transitionClasses,
          !isDesktopInsetVariation && `${position}-0`,
          !isDesktopInsetVariation && 'sm:h-full'
        )}
      >
        {header?.isVisible && Header}
        {content}
      </div>
    </div>
  )
}
